import { SVGS } from '@zonofi/gandalf-components';
import React from 'react';
import './view-sample-file-screen.scss';
import { useLocation, useNavigate } from 'react-router-dom';

export const ViewSampleFileScreen: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const fileContent = location.state?.fileContent ?? '';

  return (
    <div className="view-sample-file-screen">
      <div className="view-sample-file-screen-header">
        <img
          src={SVGS.BackIcon}
          alt=""
          className="view-sample-file-screen-header-icon"
          onClick={() => {
            navigate(-1);
          }}
        />
        <span className="view-sample-file-screen-header-text primary-font-semibold">
          Sample Document
        </span>
      </div>
      <div className="view-sample-file-screen-body">
        <div className="view-sample-file-screen-body-content tertiary-font-regular">
          {fileContent}
        </div>
      </div>
    </div>
  );
};
